import React, { useState } from "react";
import { FaPencilAlt, FaRegEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";
import Header from "../../../../../../header/header";
import Navvbar from "../../../../../../header/Navvbar";
import Footer from "../../../../../../footer.js"; // Assuming you want to include the Footer as well

const MultiEdit = () => {
  const [data, setData] = useState([
    { type: "Other", name: "1-7 ALIGNERS (DUAL)", sched: 10, units: "Count by Teeth", category: "ALIGNERS", tasks: "Select Tasks", isNew: false },
    { type: "Trays Process", name: "1-7 ALIGNERS (SINGLE)", sched: 5, units: "Count by Teeth", category: "ALIGNERS", tasks: "6 Tasks Selected", isNew: false },
    { type: "Removable Hawley Retainer", name: "3D PRINTED MODE", sched: 10, units: "Count by Arches", category: "", tasks: "Select Tasks", isNew: false }
  ]);

  const categoryOptions = [
    "",
    "Removable",
    "IMPLANTS",
    "SUNDRY",
    "ORTHODONTIC",
    "ALIGNERS",
    "BLEACHING TRAYS",
    "ZIRCONIA",
    "GUARDS"
  ];

  const handleAdd = () => {
    const newRow = {
      type: "Click to select category",
      name: "",
      sched: 10,
      units: "Count by Teeth",
      category: "",
      tasks: "Select Tasks",
      isNew: true
    };
    setData([newRow, ...data]);
  };

  const handleDelete = (index) => {
    const updated = data.filter((_, i) => i !== index);
    setData(updated);
  };

  return (
    <>
      <div style={{ marginBottom: "25px" }}>
        <Header />
        <Navvbar />
      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          {/* Sidebar from CaseSetting */}
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          >
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/usersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Account"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Owerviews"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/owersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Main Content */}
          <div className="col-md-10">
            <h2 style={{ marginBottom: '3px', color: 'rgb(51,50,50)' }}>Procedure Multi Edit</h2>
            {/* Add Button */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '9px', paddingRight: '230px' }}>
              <button
                style={{
                  marginTop: '10px',
                  padding: '3px 9px',
                  backgroundColor: '#004aad',
                  color: '#FFF',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '3px'
                }}
                onClick={handleAdd}
              >
                <span style={{ fontSize: '25px', fontWeight: 'bold' }}>+</span>Add
              </button>
            </div>
            {/* Header Row */}
            <div style={{ display: 'grid', gridTemplateColumns: '398px 169px 186px 150px 150px', alignItems: 'center', marginBottom: '5px', gap: '9px', color: 'rgb(90,89,89)' }}>
              <span style={{ fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
                <FaRegEyeSlash />Procedure Type
              </span>
              <span style={{ fontWeight: 'bold' }}>Name</span>
              <div style={{ display: 'grid', gridTemplateColumns: '60px auto', columnGap: '5px', alignItems: 'center' }}>
                <span style={{ fontWeight: 'bold' }}>Sched.</span>
                <span style={{ fontWeight: 'bold' }}>Units</span>
              </div>
              <span style={{ fontWeight: 'bold' }}>Category</span>
              <span style={{ fontWeight: 'bold' }}>Tasks</span>
            </div>
            {/* Data Rows */}
            {data.map((item, index) => (
              <div key={index} style={{ display: 'grid', gridTemplateColumns: '3.9fr 1.3fr 1fr 1.5fr 1.5fr 1.5fr 0.5fr', alignItems: 'center', marginBottom: '5px', gap: '6px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#175eac' }}>
                  {!item.isNew && <input type="checkbox" />}
                  <label style={item.type === "Click to select category" ? { color: '#175eac', cursor: 'pointer', paddingLeft: '26px' } : {}}>
                    {item.type}
                  </label>
                </div>
                <input
                  type="text"
                  value={item.name}
                  placeholder=""
                  style={{ padding: '6px 1px', border: '1px solid #ccc', borderRadius: '5px', color: 'rgb(94,92,92)' }}
                />
                <div style={{ display: 'grid', gridTemplateColumns: '60px auto', columnGap: '5px', alignItems: 'center' }}>
                  <input
                    type="number"
                    defaultValue={item.sched}
                    style={{
                      width: '60px',
                      textAlign: 'center',
                      fontSize: '15px',
                      height: '33px',
                      boxSizing: 'border-box',
                      color: 'rgb(94,92,92)',
                      ...(item.isNew ? { appearance: 'none', MozAppearance: 'textfield', WebkitAppearance: 'none' } : { appearance: 'auto', MozAppearance: 'number-input' })
                    }}
                  />
                  <select
                    defaultValue={item.units}
                    style={{ padding: '6px 1px', border: '1px solid #ccc', borderRadius: '5px', color: 'rgb(94,92,92)',width:'110px' }}
                  >
                    <option value="Count by Teeth">Count by Teeth</option>
                    <option value="Count by Arches">Count by Arches</option>
                  </select>
                </div>
                <select
                  defaultValue={item.category}
                  style={{ padding: '6px 1px', border: '1px solid #ccc', borderRadius: '5px', color: 'rgb(94,92,92)',width:'110px' }}
                >
                  {categoryOptions.map((opt, i) => (
                    <option key={i} value={opt}>{opt}</option>
                  ))}
                </select>
                <Link style={{ color: '#175eac', textDecoration: 'none' }}>{item.tasks}</Link>
                {item.isNew && (
                  <button
                    style={{
                      backgroundColor: '#004aad',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '18px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      height: '30px',
                      width: '30px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    onClick={() => handleDelete(index)}
                  >✕</button>
                )}
              </div>
            ))}
            {/* Save Button */}
            <div style={{ display: 'flex', marginTop: '10px', marginLeft: '995px' }}>
              <button
                style={{
                  marginTop: '10px',
                  padding: '8px 8px',
                  backgroundColor: '#004aad',
                  color: '#FFF',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '3px'
                }}
              >
                <FaPencilAlt style={{ fontSize: '16px' }} />
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <Footer />
      </div>
    </>
  );
};

export default MultiEdit;